import * as types from './constants';

export const getNetworkOrdersSummaryRequest = data => (
  { type: types.GET_NETWORK_ORDERS_SUMMARY_REQUEST, payload: data }
);

export const getNetworkOrdersSummaryDone = data => (
  { type: types.GET_NETWORK_ORDERS_SUMMARY_DONE, payload: data }
);

export const getNetworkOrdersSummaryFailed = errors => (
  { type: types.GET_NETWORK_ORDERS_SUMMARY_FAILED, payload: errors }
);
